import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Form, Button, Table, Badge } from "react-bootstrap";
import { FaUtensils, FaEdit, FaTrash, FaTimes, FaPlus } from "react-icons/fa";
import MasterLayout from "../../../components/layout/MasterLayout";
import "../../../assets/css/donordashboard/DonateFood.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";
import Autocomplete from "react-google-autocomplete";


const DonateFood = () => {
  const { baseUrl, loggedInDonorId } = useContext(AppContext);

  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const [foodName, setFoodName] = useState("");
  const [category, setCategory] = useState("");
  const [quantity, setQuantity] = useState("");
  const [unit, setUnit] = useState("");
  const [servings, setServings] = useState("");
  const [description, setDescription] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [phone, setPhone] = useState("");
  const [pickupDate, setPickupDate] = useState("");
  const [timeSlot, setTimeSlot] = useState("");
  const [isFresh, setIsFresh] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);

  useEffect(() => {
    if (loggedInDonorId) {
      viewAllDonations();
    }
  }, [loggedInDonorId]);

  const validateForm = () => {
    if (!foodName || !category || !quantity || !unit || !servings ||
      !description || !address || !city || !phone || !pickupDate || !timeSlot || !isFresh || !agreeTerms) {
      Swal.fire({ title: "Required!", text: "Please fill all fields", icon: "warning" });
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    if (editId) { updateDonation(); } else { createDonation(); }
  };

  const createDonation = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("donor_id", loggedInDonorId);
    formData.append("food_item_name", foodName);
    formData.append("food_category", category);
    formData.append("quantity", quantity);
    formData.append("unit", unit);
    formData.append("approx_people_served", servings);
    formData.append("food_description", description);
    formData.append("pickup_address", address);
    formData.append("city", city);
    formData.append("contact_number", phone);
    formData.append("pickup_date", pickupDate);
    formData.append("available_time", timeSlot);
    formData.append("is_freshly_prepared", isFresh ? 1 : 0);
    formData.append("agree_terms", agreeTerms ? 1 : 0);

    axios.post(`${baseUrl}/donor/dashboard/createDonation`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => {
        if (response.data.success) {
          Swal.fire({ title: "Success!", text: "Donation Created Successfully", icon: "success" });
          viewAllDonations();
          resetForm();
        } else {
          Swal.fire({ title: "Oops!", text: "Cannot Create Donation", icon: "error" });
        }
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  };

  const viewAllDonations = () => {
    axios.get(`${baseUrl}/donor/dashboard/viewAllDonation`, {
      params: { donor_id: loggedInDonorId },
    })
      .then((response) => {
        if (response.data.success) setDonations(response.data.donation);
      })
      .catch((error) => console.log(error));
  };

  const updateDonation = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("id", editId);
    formData.append("donor_id", loggedInDonorId);
    formData.append("food_item_name", foodName);
    formData.append("food_category", category);
    formData.append("quantity", quantity);
    formData.append("unit", unit);
    formData.append("approx_people_served", servings);
    formData.append("food_description", description);
    formData.append("pickup_address", address);
    formData.append("city", city);
    formData.append("contact_number", phone);
    formData.append("pickup_date", pickupDate);
    formData.append("available_time", timeSlot);
    formData.append("is_freshly_prepared", isFresh ? 1 : 0);
    formData.append("agree_terms", agreeTerms ? 1 : 0);

    axios.post(`${baseUrl}/donor/dashboard/updateDonation`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => {
        if (response.data.success) {
          Swal.fire({ title: "Updated!", text: "Donation Updated Successfully", icon: "success" });
          viewAllDonations();
          resetForm();
        }
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  };

  const deleteDonation = (id) => {
    Swal.fire({
      title: "Are You Sure?", text: "Donation will be deleted!", icon: "warning",
      showCancelButton: true, confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#165C5C",
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("id", id);
        formData.append("donor_id", loggedInDonorId);
        axios.post(`${baseUrl}/donor/dashboard/DeleteDonation`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
          .then((response) => {
            if (response.data.success) {
              Swal.fire({ title: "Deleted!", text: "Donation Deleted Successfully", icon: "success" });
              viewAllDonations();
            }
          })
          .catch((error) => console.log(error));
      }
    });
  };

  const handleEdit = (don) => {
    setEditId(don.id);
    setFoodName(don.food_item_name);
    setCategory(don.food_category);
    setQuantity(don.quantity);
    setUnit(don.unit);
    setServings(don.approx_people_served);
    setDescription(don.food_description);
    setAddress(don.pickup_address);
    setCity(don.city);
    setPhone(don.contact_number);
    setPickupDate(don.pickup_date);
    setTimeSlot(don.available_time);
    setIsFresh(don.is_freshly_prepared == 1);
    setAgreeTerms(don.agree_terms == 1);
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setEditId(null);
    setFoodName(""); setCategory(""); setQuantity(""); setUnit("");
    setServings(""); setDescription(""); setAddress(""); setCity("");
    setPhone(""); setPickupDate(""); setTimeSlot("");
    setIsFresh(false); setAgreeTerms(false);
    setShowForm(false);
  };

  const getStatusBadge = (status) => {
    const map = {
      pending: { label: "Pending", className: "df-badge df-badge-pending" },
      picked_up: { label: "Picked Up", className: "df-badge df-badge-picked" },
      delivered: { label: "Delivered", className: "df-badge df-badge-delivered" },
      cancelled: { label: "Cancelled", className: "df-badge df-badge-cancelled" },
    };
    const s = map[(status || "pending").toLowerCase()] || map["pending"];
    return <span className={s.className}>{s.label}</span>;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    return new Date(dateStr).toLocaleDateString("en-PK", {
      day: "2-digit", month: "short", year: "numeric",
    });
  };

  useEffect(() => {
    console.log();
    setPhone(JSON.parse(localStorage.getItem("loggedInDonor")).phone);
  }, []);

  return (
    <MasterLayout>
      <Container fluid className="py-4 df-page">

        {/* ── Header ── */}
        <div className="df-page-header mb-4">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-3">
              <div className="df-header-icon">
                <FaUtensils size={22} />
              </div>
              <div>
                <h3 className="df-page-title mb-0">Donate Food</h3>
                <p className="df-page-subtitle mb-0">Manage your food donations</p>
              </div>
            </div>
            <button
              className={`df-btn ${showForm ? "df-btn-danger" : "df-btn-primary"}`}
              onClick={() => { if (showForm) { resetForm(); } else { setShowForm(true); } }}
            >
              {showForm
                ? <><FaTimes className="me-2" />Close Form</>
                : <><FaPlus className="me-2" />Add Donation</>
              }
            </button>
          </div>
        </div>

        {/* ── Form Card ── */}
        {showForm && (
          <div className="df-card mb-4">
            <div className="df-card-header">
              {editId
                ? <><FaEdit className="me-2" />Update Donation</>
                : <><FaPlus className="me-2" />Add New Donation</>
              }
            </div>
            <div className="df-card-body">
              <Form onSubmit={handleSubmit}>
                <Row className="g-3">

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="df-label">Food Name <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="df-input" type="text" placeholder="e.g., Biryani" value={foodName} onChange={(e) => setFoodName(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="df-label">Category <span className="text-danger">*</span></Form.Label>
                      <Form.Select className="df-input" value={category} onChange={(e) => setCategory(e.target.value)}>
                        <option value="">Select Category</option>
                        <option value="cooked">Cooked Food</option>
                        <option value="raw">Raw Ingredients</option>
                        <option value="packaged">Packaged Food</option>
                        <option value="bakery">Bakery Items</option>
                        <option value="beverages">Beverages</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="df-label">Quantity <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="df-input" type="number" placeholder="e.g., 5" value={quantity} onChange={(e) => setQuantity(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label className="df-label">Unit <span className="text-danger">*</span></Form.Label>
                      <Form.Select className="df-input" value={unit} onChange={(e) => setUnit(e.target.value)}>
                        <option value="">Unit</option>
                        <option value="kg">KG</option>
                        <option value="liter">Liter</option>
                        <option value="pieces">Pieces</option>
                        <option value="packets">Packets</option>
                        <option value="boxes">Boxes</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="df-label">Servings (No. of People) <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="df-input" type="number" placeholder="e.g., 10" value={servings} onChange={(e) => setServings(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="df-label">Phone <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="df-input" type="text" placeholder="03XX-XXXXXXX" value={phone} onChange={(e) => setPhone(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="df-label">City <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="df-input" type="text" placeholder="e.g., Lahore" value={city} onChange={(e) => setCity(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={8}>
                    <Form.Group>
                      <Form.Label className="df-label">Pickup Address <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="df-input" type="text" placeholder="Full pickup address" value={address} onChange={(e) => setAddress(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="df-label">Pickup Date <span className="text-danger">*</span></Form.Label>
                      <Autocomplete onError={error => console.error(error)}   className="form-control"
                        apiKey={"AIzaSyCWhWJWmD1OwglKnA6vNsY1xXhKr_QbcW8"}
                        onPlaceSelected={(place) => {
                          setPickupDate(place)
                        }}
                      />
                      {/* <Form.Control min="2026-09-28" className="df-input" type="date" value={pickupDate} onChange={(e) => setPickupDate(e.target.value)} /> */}
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="df-label">Time Slot <span className="text-danger">*</span></Form.Label>
                      <Form.Select className="df-input" value={timeSlot} onChange={(e) => setTimeSlot(e.target.value)}>
                        <option value="">Select Time</option>
                        <option value="morning">Morning (8AM - 12PM)</option>
                        <option value="afternoon">Afternoon (12PM - 4PM)</option>
                        <option value="evening">Evening (4PM - 8PM)</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group>
                      <Form.Label className="df-label">Description <span className="text-danger">*</span></Form.Label>
                      <Form.Control className="df-input" as="textarea" rows={3} placeholder="Describe the food condition, packaging, etc." value={description} onChange={(e) => setDescription(e.target.value)} />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Check className="df-check" type="checkbox" label="Food is Fresh" checked={isFresh} onChange={(e) => setIsFresh(e.target.checked)} />
                  </Col>

                  <Col md={6}>
                    <Form.Check className="df-check" type="checkbox" label="I agree to the terms and conditions" checked={agreeTerms} onChange={(e) => setAgreeTerms(e.target.checked)} />
                  </Col>

                  <Col md={12} className="text-end">
                    <button type="button" className="df-btn df-btn-outline me-2" onClick={resetForm}>Cancel</button>
                    <button type="submit" className="df-btn df-btn-primary" disabled={loading}>
                      {loading ? "Please wait..." : editId ? "Update Donation" : "Submit Donation"}
                    </button>
                  </Col>

                </Row>
              </Form>
            </div>
          </div>
        )}

        {/* ── Table Card ── */}
        <div className="df-card">
          <div className="df-card-header d-flex align-items-center justify-content-between">
            <span><FaUtensils className="me-2" />All Donations</span>
            <span className="df-count-badge">{donations.length} Total</span>
          </div>
          <div className="df-card-body p-0">
            <div className="table-responsive">
              <table className="df-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Food Name</th>
                    <th>Category</th>
                    <th>Quantity</th>
                    <th>Servings</th>
                    <th>City</th>
                    <th>Phone</th>
                    <th>Pickup Date</th>
                    <th>Time Slot</th>
                    <th>Fresh</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {donations.length === 0 ? (
                    <tr>
                      <td colSpan={12} className="df-empty">No donations found. Add your first donation above!</td>
                    </tr>
                  ) : (
                    donations.map((don, index) => (
                      <tr key={don.id}>
                        <td className="df-index">{index + 1}</td>
                        <td className="fw-semibold" style={{ color: "#0f3d3e" }}>{don.food_item_name}</td>
                        <td className="text-capitalize">{don.food_category}</td>
                        <td>{don.quantity} {don.unit}</td>
                        <td>{don.approx_people_served} people</td>
                        <td>{don.city}</td>
                        <td>{don.contact_number}</td>
                        <td>{formatDate(don.pickup_date)}</td>
                        <td className="text-capitalize">{don.available_time}</td>
                        <td>
                          {don.is_freshly_prepared == 1
                            ? <span className="df-badge df-badge-fresh-yes">Yes</span>
                            : <span className="df-badge df-badge-fresh-no">No</span>
                          }
                        </td>
                        <td>{getStatusBadge(don.status)}</td>
                        <td>
                          <div className="df-actions">
                            <button className="df-action-btn df-action-edit" onClick={() => handleEdit(don)}>
                              <FaEdit />
                            </button>
                            <button className="df-action-btn df-action-delete" onClick={() => deleteDonation(don.id)}>
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </Container>
    </MasterLayout>
  );
};

export default DonateFood;